"use client";

import { createContext, useContext } from "react";
import type { HeaderLayout } from "./header";

export interface HeaderContextValue {
  layout: HeaderLayout;
  activeValue?: string;
  placement: "bar" | "menu";
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
}

export const HeaderContext = createContext<HeaderContextValue | null>(null);

export const useHeader = (): HeaderContextValue => {
  const ctx = useContext(HeaderContext);
  if (!ctx) throw new Error("Header parts must be used within <Header>.");
  return ctx;
};

export const useHeaderMenu = () => {
  const { setMenuOpen } = useHeader();
  return { closeMenu: () => setMenuOpen(false) };
};
